/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectOptimizeFailedDtoBase
 * auto generated base class for the model ProjectOptimizeFailedDtoModel.
 *
 * Optimize failed
 */
export const ProjectOptimizeFailedDtoModelBase = ModelBase
  .named('ProjectOptimizeFailedDto')
  .props({
    __typename: types.optional(types.literal("ProjectOptimizeFailedDto"), "ProjectOptimizeFailedDto"),
    projectId: types.union(types.undefined, types.string),
    solutionId: types.union(types.undefined, types.string),
    /** Count of scheduled stops */
    scheduledStops: types.union(types.undefined, types.number),
    /** Count of unscheduled stops */
    unscheduledStops: types.union(types.undefined, types.number),
    error: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectOptimizeFailedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  get solutionId() { return this.__attr(`solutionId`) }
  get scheduledStops() { return this.__attr(`scheduledStops`) }
  get unscheduledStops() { return this.__attr(`unscheduledStops`) }
  get error() { return this.__attr(`error`) }
}
export function selectFromProjectOptimizeFailedDto() {
  return new ProjectOptimizeFailedDtoModelSelector()
}

export const projectOptimizeFailedDtoModelPrimitives = selectFromProjectOptimizeFailedDto().projectId.solutionId.scheduledStops.unscheduledStops.error
